import React, { useState, useEffect, useRef, useCallback } from 'react';
import Dropdown from '../../../Components/CustomDropdown/customdropdown';
import { useToast } from '../../../Utils/toastContext';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmContinueButton from '../../../Components/ContinueButton/continue-button';
import { updateFormData } from '../../../Redux/store/onboardingFormSlice';
import AddressAutocomplete from '../../../Components/addressInput/address-input';
import AddUserPopup from '../../../Components/add-joint-accounts/Add-User-Popup';
import CustomDropdownWithFetch from '../../../Components/CustomDropdown/custom-dropdown-fetchAPI';
import {
  setStepStatusShareholder,
  setRejectedFieldsShareholder,
} from '../../../Redux/store/onboardingFormSlice';
import LabelWithStatus from '../../../Components/onboarding/label-with-status';
import { clearFileIdsRedux } from '../../../Redux/store/userSlice';
import DropdownTDFetch from '../../../Components/CustomDropdown/custom-td-dropdown-fetchapi';
import CountryDropdown from '../../../Components/CustomDropdown/user-countries';
import CustomTdDropdown from '../../../Components/CustomDropdown/custom-td-dropdown';
import ReviewPopup from '../../../Components/onboarding/review-popup';
import StatusButton from '../../../Components/onboarding/status-button';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ConfirmResetButton from '../../../Components/ContinueButton/reset-button';

const TrustInfo = ({ setCurrentStep }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const clientIdRedux = useSelector((state) => state.user.clientId);
  const userStatus = useSelector((state) => state.user.userStatus);
  const { shareholderId } = useParams();
  const rejectedFields = useSelector(
    (state) => state.form.rejectedFieldsShareholder,
  );
  const [isValidAbn, setIsValidAbn] = useState(false);

  const [profilePayloadFile, setProfilePayloadFile] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const dropdownRef = useRef();

  const buttonRefs = useRef({});
  const [accountTypeData, setAccountTypeData] = useState([]);
  const [accountType, setAccountType] = useState(1);
  const [jointAccountUser, setJointAccountUser] = useState(1);
  const [accountTypeLabel, setAccountTypeLabel] = useState('Individual');
  const [refNumber, setRefNumber] = useState(new Array(7).fill(''));
  const [advisorId, setAdvisorId] = useState('');
  const [isAdvisorExist, setIsAdvisorExist] = useState(true);
  const [advisorName, setAdvisorName] = useState('Brian	Vaughan');
  const [fullName, setfullName] = useState('');
  const [formerNames, setFormerNames] = useState({
    verification_id: null,
    value: [],
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [businessNatureData, setBusinessNatureData] = useState([]);
  const [preselectedBusinessNature, setPreselectedBusinessNature] = useState(
    {},
  );
  const [newFormerName, setFormerName] = useState('');
  const [finServicesLicense, setFinServicesLicense] = useState('');
  const [DoI, setDoI] = useState('');
  const [revenueTypeOptions, setRevenueTypeOptions] = useState([]);
  const [accountPurpose, setAccountPurpose] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const countryTypeOptions = [
    { value: 1, label: 'Australia' },
    { value: 2, label: 'Canada' },
    // Add more options dynamically if needed
  ];
  const [currencyData, setCurrencyData] = useState([]);
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: 'AUD',
  });
  const [preselectedAccountType, setpreselectedAccountType] = useState({
    value: 1,
    label: 'Regulated Trust',
  });
  const [toCurrency, setToCurrency] = useState({
    verification_id: null,
    value: {
      id: 2,
      name: 'AUD',
      symbol: '$',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [toCurrencyText, setToCurrencyText] = useState('AUD');
  const [fullSettlorName, setFullSettlorName] = useState('');
  const stepStatus = useSelector((state) => state.form.stepStatusShareholder);
  const [jointAccountUserLabel, setJointAccountUserLabel] = useState('');
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState('');
  const [countryType, setCountryType] = useState(14);
  const [countryTypeRiskFactor, setCountryTypeRiskFactor] = useState('low');
  const [countryTypeLabel, setCountryTypeLabel] = useState('Australia');
  const [purpose, setPurpose] = useState('');
  const [preselectedInevstmentAmount, setpreselectedInevstmentAmount] =
    useState({});
  const [countryCodeData, setCountryCodeData] = useState([
    {
      value: 1,
      label: 'Australia',
    },
  ]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 1,
    label: 'Australia',
  });
  const [fileAbn, setFileAbn] = useState(null);

  const [countryCode, setCountryCode] = useState(1);
  const [countryCodeText, setCountryCodeText] = useState('Australia');
  const [redAddress, setRedAddress] = useState('');
  const [investmentAmount, setInvestmentAmount] = useState(null);
  const [investmentAmountText, setInvestmentAmountText] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
  });
  const [stateId, setStateId] = useState(null);
  const [stateText, setStateText] = useState('');
  const [abn, setAbn] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [acn, setAcn] = useState('');
  const [trustTypeText, setTrustTypeText] = useState('');
  const [trustTypeID, setTrustTypeID] = useState('');
  const [members, setMembers] = useState([]);
  const fileInputRef = useRef(null);
  const abnFileRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openDropdownRevenue, setOpenDropdownRevenue] = useState(null);

  const [preview, setPreview] = useState('/avatar.svg');
  const { showToast } = useToast();
  const [jointAccountId, setJointAccountId] = useState(null);
  const [fileAttorney, setFileAttorney] = useState(null);
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [actualData, setactualData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const containerRef = useRef(null);
  const [expectedAmountData, setExpectedAmountData] = useState([]);
  const [nameFromBirth, setNameFromBirth] = useState('yes');
  const [clientId, setClientId] = useState('INV1947534324');
  const [activity, setActivity] = useState({
    verification_id: null,
    value: {
      id: null,
      name: '',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [activityText, setActivityText] = useState('');
  const [otherActivity, setOtherActivity] = useState('');
  const [companyTypeId, setCompanyTypeId] = useState(1);
  const [companyTypeText, setCompanyTypeText] = useState('Proprietary Company');
  const [registeredAddress, setRegisteredAddress] = useState('');
  const [principalAddress, setPrincipalAddress] = useState('');
  const [companySecretary, setCompanySecretary] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');
  const [transactionLevel, setTransactionLevel] = useState('');
  const [source, setSource] = useState('');
  const [foreignRegistered, setForeignRegistered] = useState('yes');
  const [EIN, setEIN] = useState('');
  const [arbn, setArbn] = useState('');
  const [agentName, setAgentName] = useState('');
  const [agentAddress, setAgentAddress] = useState('');
  const [stockExchangeText, setStockExchangeText] = useState('');
  const [stockExchangeId, setStockExchangeId] = useState('');
  const [stockRegistered, setStockRegistered] = useState('yes');
  const [registrationNumber, setRegistrationNumber] = useState('');
  const [businessActivityData, setBusinessActivityData] = useState([]);
  const [trustTypeData, setTrustTypeData] = useState([]);
  const [registeredAddressApi, setRegisteredAddressApi] = useState('');
  const [preselectedActivity, setPreselectedActivity] = useState({});
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState('');
  const [foreignAddress, setForeignAddress] = useState('');
  const [preSelectedCompanyType, setPreSelectedCompanyType] = useState({
    value: 1,
    label: 'Proprietary Company',
  });
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [registeredAddressCity, setRegisteredAddressCity] = useState(null);
  const [registeredAddressCountry, setRegisteredAddressCountry] =
    useState(null);
  const [registeredAddressState, setRegisteredAddressState] = useState(null);
  const [preselectedCountryType, setPreselectedCountryType] = useState({
    value: 14,
    label: 'Australia',
  });
  const [preselectedTrustType, setPreselectedTrustType] = useState({});
  const [abnStatus, setAbnStatus] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const validateAbn = async () => {
    const cleanedAbn = abn.value?.replace(/\s+/g, '');

    if (!cleanedAbn || cleanedAbn.length !== 11) return;
    let toastMessage = null;
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/abn-lookup/${cleanedAbn}`,
      );
      if (response.status == 200) {
        setIsValidAbn(true);
      } else {
        toastMessage = { message: response.message, type: 'error' };
        setIsValidAbn(false);
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsValidAbn(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const fieldLabelMap = {
    country_of_formation_id: 'Country of formation',
    trust_logo_url: 'Trust Logo',
    purpose_of_opening_account: 'Purpose of opening account',
    trust_full_name: 'Full Name of the Trust',
    former_trading_names:
      'All business names used by the trust and any other name under which the trust operates',
    settlor_full_name: 'The full name of the settlor of the trust',
    registered_address: "Trust's Registered Address",
    registration_number: 'Registration Number',
    abn: 'ABN Lookup',
    business_activities:
      'Nature of the business activities conducted by the trust',
    business_activities_description: 'Other business activity description',
  };
  const companyTypeData = [
    {
      value: 1,
      label: 'Proprietary Company',
    },
    {
      value: 2,
      label: 'Public Company',
    },
  ];
  const stateData = [
    {
      value: 1,
      label: 'New South Wales(NSW)',
    },
  ];
  const stockExchangeData = [
    {
      value: 1,
      label: 'USA - NASDAQ Stock Mark',
    },
  ];

  const handleDropdownToggle = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const handleSelectCompanyType = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setCompanyTypeId(selectedOption.value);
    setCompanyTypeText(selectedOption.label);
  };
  const handleDeleteFileAbn = () => {
    setFileAbn(null);
    if (abnFileRef.current) {
      abnFileRef.current.value = null;
    }
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const handleFileChangeAbn = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAbn(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleSelectDomicileCountry = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setCountryCode(selectedOption.value);
    setCountryCodeText(selectedOption.label);
  };
  const handleNameForeignRegistered = (e) => {
    setForeignRegistered(e.target.value);
  };
  const addMember = () => {
    const fieldTemplate = {
      verification_id: null,
      value: '',
      status: 'pending',
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    };

    setMembers((prev) => [
      ...prev,
      {
        revenueType: { ...fieldTemplate },
        countryType: { ...fieldTemplate },
        assetValue: { ...fieldTemplate },
      },
    ]);
  };
  const removeMember = (index) => {
    setMembers((prev) => prev.filter((_, i) => i !== index));
  };
  const updateMember = (index, key, newValue, newErrors = null) => {
    setMembers((prev) =>
      prev.map((member, i) => {
        if (i !== index) return member;

        // If field is an object field with `{ value }`
        if (
          member[key] &&
          typeof member[key] === 'object' &&
          'value' in member[key]
        ) {
          return {
            ...member,
            [key]: {
              ...member[key],
              value: newValue.value ?? newValue, // value
              label: newValue.label ?? newValue.value, // **add label**
              raw: newValue.raw ?? member[key].raw,
              display: newValue.display ?? member[key].display,
            },
            errors: newErrors ?? member.errors,
          };
        }

        // Simple update
        return { ...member, [key]: newValue };
      }),
    );
  };

  const handleStockRegistered = (e) => {
    setStockRegistered(e.target.value);
  };
  const handleSelectActivity = (selectedOption) => {
    setActivity({
      ...activity,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
    setOtherActivity({
      verification_id: null,
      value: '',
      status: 'pending',
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const handleAbn = async () => {
    let toastMessage = null;
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/abn-lookup/${abn.value}`,
      );
      if (response.status == 200) {
        if (!response.data.valid) {
          setAbnStatus({
            ...abnStatus,
            value: 'Invalid',
          });
          toastMessage = {
            message: response.data.error,
            type: 'error',
          };
        }
        if (response.data.valid) {
          setAbnStatus({
            ...abnStatus,
            value: response.data.entity_status,
          });
          toastMessage = {
            message: response.message,
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleContinue = (isFinal) => {
    // your logic like setCurrentStep(2), API calls, etc.
    if (!registeredAddress.value || !registeredAddressCountry) {
      showToast(
        "Please enter valid address of the trust's registered office",
        'error',
      );
      return true;
    }
    if (!fullName.value) {
      showToast('Please enter full name', 'error');
      return true;
    }
    if (!trustTypeID) {
      showToast('Please select the type trust category', 'error');
      return true;
    }
    if (!countryType) {
      showToast(
        'Please select the country in which the trust was established',
        'error',
      );
      return true;
    }
    if (!fullSettlorName.value) {
      showToast(
        'Please enter The full name of the settlor of the trust',
        'error',
      );
      return true;
    }
    if (!registrationNumber.value) {
      showToast('Please enter a valid registration number', 'error');
      return true;
    }
    if (!activity) {
      showToast(
        'Please select a nature of the business activities conducted by the trust',
        'error',
      );
      return true;
    }
    if (countryType == 14 && (!abn.value || !isValidAbn)) {
      showToast('Please enter a valid ABN', 'error');
      return true;
    }
    const hasAtLeastOneValidRow = members.some(
      (member) =>
        member.revenueType?.value &&
        member.countryType?.value &&
        member.assetValue?.raw &&
        !isNaN(parseFloat(member.assetValue.raw)),
    );

    if (!hasAtLeastOneValidRow) {
      showToast('Please fill at least one income or asset row.', 'error');
      return;
    }
    setLoading(true);
    handlesave(isFinal);
  };
  const handleBack = () => {};
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/stakeholder/trust/trust-information/reset/${shareholderId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
        getDetailsWithVerification();
        const responseStatus = await GetAPIcalls(
          `/api/v1/onboarding/stakeholder/status/${shareholderId}`,
        );
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatusShareholder(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleSelectBusinessNature = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setBusinessNature({
      ...businessNature,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handleSelectStateData = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setStateId(selectedOption.value);
    setStateText(selectedOption.label);
  };
  const handleSelectStockExchange = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setStockExchangeId(selectedOption.value);
    setStockExchangeText(selectedOption.label);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  const handleSelectAccountType = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setAccountType(selectedOption.value);
    setAccountTypeLabel(selectedOption.label);
  };
  const handleSelectCountryType = (selectedOption) => {
    setCountryType(selectedOption.value);
    setCountryTypeLabel(selectedOption.label);
    setCountryTypeRiskFactor(selectedOption.risk_factor);
  };
  const handleSelectJointAccountUser = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setJointAccountUser(selectedOption.value);
    setJointAccountUserLabel(selectedOption.label);
  };
  const handleSelectInvestmentAmount = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setInvestmentAmountText({
      ...investmentAmountText,
      value: selectedOption.label,
    });
  };
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData('text').slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      setRefNumber(pasteData.split(''));
    }
    event.preventDefault();
  };
  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      // Only allow numbers
      const newOtp = [...refNumber];
      newOtp[index] = value;
      setRefNumber(newOtp);
      if (value && index < 6) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };
  // Handle backspace
  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace' && !refNumber[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };
  const handleAddFormerName = (e) => {
    if (e.key === 'Enter' && newFormerName.trim() !== '') {
      setFormerNames((prev) => ({
        ...prev,
        value: [...prev.value, newFormerName.trim()],
      }));
      setFormerName(''); // clear input
    }
  };

  const handleRemoveFormerName = (indexToRemove) => {
    setFormerNames(formerNames.filter((_, index) => index !== indexToRemove));
  };
  const handleSelectToCurrency = (selectedOption) => {
    setToCurrency({
      ...toCurrency,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
        symbol: selectedOption.symbol,
      },
    });
  };

  const handleSelectTrustType = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setTrustTypeID(selectedOption.value);
    setTrustTypeText(selectedOption.label);
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };
  const UploadCSVApi = async (file) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const formData3 = new FormData();
    formData3.append('file', file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: formData3,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const mapIncomeAssetsToMembers = (apiData = []) => {
    return apiData.map((item) => ({
      revenueType: {
        value: item?.revenue_type?.value?.id ?? null,
        label: item?.revenue_type?.value?.name ?? '',
      },

      countryType: {
        value: item?.country?.value?.id ?? null,
        label: item?.country?.value?.name ?? '',
      },

      assetValue: {
        raw: item?.value?.value ?? '',
        display: item?.value?.value
          ? new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Number(item.value.value))
          : '',
      },
    }));
  };

  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/stakeholder/trust/trust-information/preview/${shareholderId}/verifications`,
      );

      if (response.status == 200) {
        if (response.data) {
          setAccountType(response.data.trust_type.value.id);
          setAccountTypeLabel(response.data.trust_type.value.label);
          setpreselectedAccountType({
            value: response.data.trust_type.value.id,
            label: response.data.trust_type.value.label,
          });
          setCountryType(response.data.country_of_established.value.id);
          setCountryTypeLabel(response.data.country_of_established.value.name);
          setCountryTypeRiskFactor('low');
          setPreselectedCountryType({
            value: response.data.country_of_established.value.id,
            label: response.data.country_of_established.value.name,
          });
          setProfilePayloadFile(response.data?.trust_logo_url);
          setPreview(
            response.data?.trust_logo_url?.value?.presigned_url == ''
              ? '/avatar.svg'
              : response.data?.trust_logo_url?.value?.presigned_url,
          );
          setfullName(response.data.trust_full_name);
          setFullSettlorName(response.data.settlor_full_name);
          setFormerNames(response.data.all_trading_names);
          setTrustTypeID(response.data.trust_type_category.value.id);
          setTrustTypeText(response.data.trust_type_category.value.label);
          setPreselectedTrustType({
            value: response.data.trust_type_category.value.id,
            label: response.data.trust_type_category.value.label,
          });

          setRegisteredAddress(response.data.registered_address);
          setRegisteredAddressApi(response.data.registered_address.value);
          setRegistrationNumber(response.data.registration_number);
          if (response.data.country_of_established.value.id) {
            setAbn(response.data.abn);
            setIsValidAbn(true);
          }
          setActivity(response.data.business_activities);
          if (response.data.business_activities.value.id == 6) {
            setOtherActivity(response.data.business_activities_description);
          }
          setPreselectedActivity({
            value: response.data.business_activities.value.id,
            label: response.data.business_activities.value.label,
          });
          if (response.data.income_assets?.length) {
            const mappedMembers = mapIncomeAssetsToMembers(
              response.data.income_assets,
            );
            setMembers(mappedMembers);
          }
        } else {
          setAccountType(1);
          setAccountTypeLabel('Individual');
          setpreselectedAccountType({
            value: 1,
            label: 'Regulated Trust',
          });
          setCountryType(14);
          setCountryTypeLabel('Australia');
          setCountryTypeRiskFactor('low');
          setPreselectedCountryType({
            value: 14,
            label: 'Australia',
          });
          setProfilePayloadFile({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPreview('/avatar.svg');
          setfullName('');
          setFormerNames({
            verification_id: null,
            value: [],
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setTrustTypeID('');
          setTrustTypeText('');
          setPreselectedTrustType({});
          setRegisteredAddress('');
          setRegisteredAddressApi('');
          setRegistrationNumber('');
          setSource('');
          setAccountPurpose({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setBusinessNature(null);
          setPreselectedBusinessNature({});
          setAbn({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAbnStatus({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setActivity({
            verification_id: null,
            value: {
              id: null,
              name: '',
            },
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setOtherActivity('');
          setPreselectedActivity({});
          setToCurrency({
            verification_id: null,
            value: {
              id: 2,
              name: 'AUD',
              symbol: '$',
            },
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCurrency({
            value: 2,
            label: 'AUD',
          });
          setInvestmentAmountText({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
          });
          setpreselectedInevstmentAmount({});
          setMembers([]);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg'];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast('Please upload an image in PNG or JPEG format.', 'error');
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast('File size must be less than 10MB.', 'error');
      return;
    }
    if (file) {
      let toastMessage = null;
      setLoading(true);
      try {
        const response = await UploadCSVApi(file);
        if (response.status == '201') {
          toastMessage = {
            message: 'Logo uploaded successfully',
            type: 'success',
          };
          const imageUrl = URL.createObjectURL(file);
          setPreview(imageUrl);
          setProfilePayloadFile({
            ...profilePayloadFile,
            value: response.data,
          });
        }
      } catch (err) {
        setPreview('/avatar.svg');
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    event.target.value = '';
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getAllLocationDetailsRegisteredAddress = async () => {
    try {
      const response = await getLocation(
        registeredAddress.value.country &&
          registeredAddress.value.country.name &&
          registeredAddress.value.country.name !== ''
          ? registeredAddress.value.country.name
          : registeredAddress.value.country,
        registeredAddress.value.state &&
          registeredAddress.value.state.name &&
          registeredAddress.value.state.name !== ''
          ? registeredAddress.value.state.name
          : registeredAddress.value.state,
        registeredAddress.value.city &&
          registeredAddress.value.city.name &&
          registeredAddress.value.city.name !== ''
          ? registeredAddress.value.city.name
          : registeredAddress.value.city,
      );
      setRegisteredAddressCountry(response.country_id);
      setRegisteredAddressState(response.state_id);
      setRegisteredAddressCity(response.city_id);
    } catch (err) {
      setRegisteredAddressCountry(null);
      setRegisteredAddressState(null);
      setRegisteredAddressCity(null);
      showToast(err.message, 'error');
    }
  };
  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == 'onboarding' ? true : false;
    let apiUrl = isOnbaording
      ? `${BASE_URL}/api/v1/onboarding/stakeholder/trust/trust-information/submit/${shareholderId}`
      : `${BASE_URL}/api/v1/onboarding/stakeholder/trust/trust-information/update/${shareholderId}`;
    let bodyData = {};
    let registeredAddressAddress = {};
    if (registeredAddressApi != null) {
      registeredAddressAddress = {
        address_line_1:
          registeredAddressApi.address_line_1 == null
            ? registeredAddressApi.google_address
            : registeredAddressApi.address_line_1,
        address_line_2:
          registeredAddressApi.address_line_2 == null
            ? null
            : registeredAddressApi.address_line_2,
        city_id:
          registeredAddressApi.city != null
            ? registeredAddressApi.city.id
            : null,
        state_id:
          registeredAddressApi.city != null
            ? registeredAddressApi.city.state_id
            : null,
        country_id: registeredAddressCountry,
        zip_code: registeredAddressApi.zip_code,
        google_address: registeredAddressApi.google_address,
      };
    } else {
      registeredAddressAddress = {
        address_line_1:
          registeredAddress.value.street == ''
            ? registeredAddress.value.full
            : registeredAddress.value.street,
        address_line_2: registeredAddress.value.route,
        city_id: registeredAddressCity,
        state_id: registeredAddressState,
        country_id: registeredAddressCountry,
        zip_code: registeredAddress.value.zip,
        google_address: registeredAddress.value.full,
      };
    }
    if (registeredAddressAddress.city_id === null) {
      showToast(
        "Please enter valid address of the company's principal place of business.",
        'error',
      );
      return; // Stop execution if city_id is missing
    }
    const incomeAssetsPayload = members.map((member) => ({
      revenue_type: member.revenueType.value, // from member.revenueType.value
      country_id: member.countryType.value, // from member.countryType.value
      value: parseFloat(member.assetValue.raw), // convert raw string to number
      currency_id: toCurrency.value.id,
    }));
    if (countryType == 14) {
      bodyData = {
        trust_type: accountType,
        trust_type_category: trustTypeID,
        trust_full_name: fullName.value,
        country_of_established_id: countryType,
        trust_logo_file: profilePayloadFile?.value
          ? {
              file_id: profilePayloadFile.value.file_id,
              file_name: profilePayloadFile.value.file_name,
            }
          : null,
        settlor_full_name: fullSettlorName.value,
        all_trading_names: formerNames.value,
        registered_address: registeredAddressAddress,
        registration_number: registrationNumber.value,
        business_activities_description: otherActivity.value,
        business_activities: activity.value.id,
        abn: abn.value,
        abn_status: 'active',
        income_assets: incomeAssetsPayload,
        is_submitted: isFinal,
      };
    } else {
      bodyData = {
        trust_type: accountType,
        trust_type_category: trustTypeID,
        trust_full_name: fullName.value,
        country_of_established_id: countryType,
        trust_logo_file: profilePayloadFile?.value
          ? {
              file_id: profilePayloadFile.value.file_id,
              file_name: profilePayloadFile.value.file_name,
            }
          : null,
        settlor_full_name: fullSettlorName.value,
        all_trading_names: formerNames.value,
        registered_address: registeredAddressAddress,
        registration_number: registrationNumber.value,
        business_activities_description: otherActivity.value,
        business_activities: activity.value.id,
        income_assets: incomeAssetsPayload,
        is_submitted: isFinal,
      };
    }

    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? 'POST' : 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 201 || response.status == 200) {
        if (isFinal) {
          setCurrentStep(2);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          const responseStatus = await GetAPIcalls(
            `/api/v1/onboarding/stakeholder/status/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              'Information has been saved successfully. Please submit to proceed further.',
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/api/v1/users/countries?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
          risk_factor: item.risk_factor,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };
  const getEnum = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/stakeholder/trust/trust-information/enums`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.trust_types.forEach((profile) => {
          AccountData.push({
            value: profile.value,
            label: profile.label,
          });
        });
        setAccountTypeData(AccountData);
        setpreselectedAccountType(AccountData[0]);
        setAccountType(AccountData[0].value);
        const buninessActivityData = [];
        response.data.business_activities.forEach((profile) => {
          buninessActivityData.push({
            value: profile.value,
            label: profile.label,
          });
        });
        setBusinessActivityData(buninessActivityData);

        const companyData = [];
        response.data.trust_type_categories.forEach((profile) => {
          companyData.push({
            value: profile.value,
            label: profile.label,
          });
        });
        setTrustTypeData(companyData);

        const statelistData = [];
        response.data.revenue_types.forEach((profile) => {
          statelistData.push({
            value: profile.value,
            label: profile.label,
          });
        });
        setRevenueTypeOptions(statelistData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setAccountTypeData([]);
          setpreselectedAccountType({});
          setAccountType(null);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setAccountTypeData([]);
      setpreselectedAccountType({});
      setAccountType(null);
    }
  };
  useEffect(() => {
    if (
      (registeredAddress.value && registeredAddress.value.country) ||
      (registeredAddress.value && registeredAddress.value.country.name)
    ) {
      getAllLocationDetailsRegisteredAddress();
    }
  }, [registeredAddress]);
  useEffect(() => {
    getEnum();
  }, []);
  useEffect(() => {
    if (stepStatus.length > 0 && stepStatus[0].status != 'DRAFT') {
      getDetailsWithVerification();
    }
  }, [stepStatus]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {countryTypeRiskFactor == 'high' && (
          <div className="mb-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
            <img src="/tick-error.svg" alt="Info" className="w-5 h-5 mr-2" />
            <span>
              It looks like we’re
              <strong> not able to accept applications</strong> from this
              country at the moment.{' '}
            </span>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[0].status == 'IN_REVIEW' ||
            stepStatus[0].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[0].status == 'APPROVED' && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.TRUST_INFORMATION?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.TRUST_INFORMATION.rejected_fields.length === 1
                ? 'The following field requires correction:'
                : 'The following fields require correction:'}{' '}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.TRUST_INFORMATION.rejected_fields.map((field) => (
                <span
                  key={field}
                  className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                >
                  {fieldLabelMap[field] || field.replace(/_/g, ' ')}
                </span>
              ))}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <img
              src="/briefcase.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">Trust Information</h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="mb-2">
                <Dropdown
                  label={
                    <>
                      Select the type of trust
                      <span className="text-red-500">*</span>
                    </>
                  }
                  options={accountTypeData}
                  onSelect={handleSelectAccountType}
                  preselectedValue={preselectedAccountType}
                />
              </div>
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col">
              <CustomDropdownWithFetch
                label={
                  <>
                    Country in which the trust was established
                    <span className="text-red-500">*</span>
                  </>
                }
                search={true}
                preselectedValue={preselectedCountryType}
                onSelect={handleSelectCountryType}
                colorLabel=""
                fetchOptions={getCountries} // <-- pass fetch function, not options
              />
            </div>
          </div>
          {countryTypeRiskFactor != 'high' && (
            <>
              <div className="bg-white">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  {/* Profile Picture Section */}
                  <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                    <LabelWithStatus
                      id="companyLogo"
                      label={fieldLabelMap.trust_logo_url}
                      required={false}
                      fieldData={profilePayloadFile}
                      handleStatusClick={handleStatusClick}
                    />
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-16 h-16 flex items-center justify-center">
                        <img
                          src={preview}
                          alt="Avatar"
                          className={`${
                            profilePayloadFile.status == 'rejected'
                              ? 'border-[#FF5050] border-2'
                              : ''
                          } w-14 h-14 rounded-full`}
                        />
                      </div>
                      <div className="flex flex-col space-y-1">
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                        />
                        <button
                          onClick={handleUploadClick}
                          disabled={preview.status == 'approved'}
                          className={`${
                            preview.status == 'rejected'
                              ? 'border-[#FF5050] border-2'
                              : 'border-black border-2'
                          }
                                       bg-white text-black text-xs px-3 py-1 rounded-full`}
                        >
                          Upload from Device
                        </button>
                      </div>
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.trust_full_name}
                        required={true}
                        fieldData={fullName}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="fullName"
                        name="firstName"
                        type="text"
                        value={fullName?.value}
                        placeholder="Your Full Name"
                        disabled={fullName.status == 'approved'}
                        className={`${
                          fullName.status == 'rejected'
                            ? 'border-[#FF5050] border-2'
                            : ''
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setfullName({
                            ...fullName,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.settlor_full_name}
                        required={true}
                        fieldData={fullSettlorName}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="fullNameSetllor"
                        name="fullNameSetllor"
                        type="text"
                        value={fullSettlorName.value}
                        placeholder="Full Name"
                        disabled={fullSettlorName.status == 'approved'}
                        className={`${
                          fullSettlorName.status == 'rejected'
                            ? 'border-[#FF5050] border-2'
                            : ''
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setFullSettlorName({
                            ...fullSettlorName,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.former_trading_names}
                        required={false}
                        fieldData={formerNames}
                        handleStatusClick={handleStatusClick}
                      />
                      <div
                        className={`${
                          formerNames.status == 'rejected'
                            ? 'border-[#FF5050] border-2'
                            : 'border-gray-300'
                        } mt-1 border rounded-md  p-2 flex flex-wrap gap-2`}
                      >
                        {' '}
                        {formerNames.value && formerNames.value.length > 0 && (
                          <>
                            {' '}
                            {formerNames.value.map((formerName, index) => (
                              <div
                                key={index}
                                className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                              >
                                <span>{formerName}</span>
                                <button
                                  type="button"
                                  onClick={() => handleRemoveFormerName(index)}
                                  className="ml-2 text-gray-700 hover:text-gray-700"
                                >
                                  &times;
                                </button>
                              </div>
                            ))}
                          </>
                        )}
                        <input
                          type="text"
                          value={newFormerName}
                          onChange={(e) => setFormerName(e.target.value)}
                          onKeyDown={handleAddFormerName}
                          placeholder="Add name"
                          disabled={formerNames.status == 'approved'}
                          className="border-none focus:outline-none flex-grow text-sm"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                    <div className="">
                      <Dropdown
                        label={
                          <>
                            Select the Type Trust Category
                            <span className="text-red-500">*</span>
                          </>
                        }
                        options={trustTypeData}
                        onSelect={handleSelectTrustType}
                        preselectedValue={preselectedTrustType}
                      />
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.registered_address}
                        required={true}
                        fieldData={registeredAddress}
                        handleStatusClick={handleStatusClick}
                      />
                      <AddressAutocomplete
                        value={
                          registeredAddress?.value?.full ||
                          registeredAddressApi?.google_address ||
                          ''
                        }
                        className={
                          registeredAddress.status === 'rejected'
                            ? 'border-[#FF5050] border-2 w-full'
                            : 'w-full'
                        }
                        disabled={registeredAddress.status === 'approved'}
                        onSelect={(addr) => {
                          setRegisteredAddressApi(null); // ok
                          setRegisteredAddress({
                            ...registeredAddress,
                            value: addr, // ✅ this now controls the textarea
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {countryTypeRiskFactor != 'high' && (
          <>
            <div className="bg-white shadow-md rounded-md p-4 mt-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                  <div className="">
                    <LabelWithStatus
                      id="registrationNumber"
                      label={fieldLabelMap.registration_number}
                      required={true}
                      fieldData={registrationNumber}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="RegistrationNumber"
                      name="RegistrationNumber"
                      type="text"
                      value={registrationNumber.value}
                      placeholder="Enter Registration Number"
                      disabled={registrationNumber.status == 'approved'}
                      className={`${
                        registrationNumber.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setRegistrationNumber({
                          ...registrationNumber,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                  {countryType == 14 && (
                    <>
                      <div className="mt-4">
                        <LabelWithStatus
                          id="companyLogo"
                          label={fieldLabelMap.abn}
                          required={true}
                          fieldData={abn}
                          handleStatusClick={handleStatusClick}
                        />
                        <div
                          className={`${
                            abn.status == 'rejected'
                              ? 'border-[#FF5050] border-2'
                              : ''
                          }  flex items-center border px-2 rounded-lg w-full`}
                        >
                          <input
                            id="abn"
                            name="abn"
                            type="text"
                            value={abn.value}
                            placeholder="Enter ABN"
                            disabled={abn.status == 'approved'}
                            onBlur={validateAbn}
                            className={` h-[2.813rem] dark:focus-visible:ring-[#4E4E4E] dark:text-white text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none  w-full leading-tight focus:outline-none focus:shadow-outline`}
                            onChange={(e) => {
                              setAbn({
                                ...abn,
                                value: e.target.value,
                              });
                              setIsValidAbn(false);
                            }}
                          />
                          {isValidAbn != null && (
                            <span
                              className={`material-symbols-outlined ml-2 text-xl transition-all duration-300 ${
                                isValidAbn
                                  ? 'text-green-500 scale-110'
                                  : 'text-red-500 scale-110'
                              }`}
                            >
                              {isValidAbn ? 'check_circle' : 'cancel'}
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Client ID Section */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                  <div className="">
                    <LabelWithStatus
                      id="companyLogo"
                      label={fieldLabelMap.business_activities}
                      required={false}
                      fieldData={activity}
                      handleStatusClick={handleStatusClick}
                    />
                    <Dropdown
                      label=""
                      options={businessActivityData}
                      preselectedValue={preselectedActivity}
                      onSelect={handleSelectActivity}
                      disabled={activity.status == 'approved'}
                      parentClass={
                        activity.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      }
                    />
                  </div>
                  {activity.value.id == 6 && (
                    <div className="mt-4">
                      <LabelWithStatus
                        id="abn"
                        label="Please mention other business activity"
                        required={true}
                        fieldData={otherActivity}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="others"
                        name="others"
                        type="text"
                        value={otherActivity.value}
                        placeholder="Other activity"
                        className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) =>
                          setOtherActivity({
                            ...otherActivity,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {countryTypeRiskFactor != 'high' && (
        <div className="bg-white shadow-md rounded-md p-4 mt-4 mb-10">
          {' '}
          <div className="flex justify-between font-medium items-center mb-4">
            <div className="flex flex-col">
              <h2 className="text-lg">
                Income and assets (including location) of the trust
              </h2>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
              {/* Table Head */}
              <thead className="bg-[#F9F9F9] text-labelColour font-semibold">
                <tr>
                  <th className="p-2 w-[40px]"></th>
                  <th className="p-2">Type of Revenue</th>
                  <th className="p-2">Location</th>
                  <th className="p-2">Value of asset or income</th>
                  <th className="p-2 w-[40px]"></th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody>
                {members.map((member, idx) => (
                  <tr key={idx} className="border-t bg-white align-top">
                    {/* Index */}
                    <td className="p-2 font-medium text-gray-600">
                      {(idx + 1).toString().padStart(2, '0')}.
                    </td>

                    {/* Revenue Type Dropdown */}
                    <td className="px-4 py-2">
                      <CustomTdDropdown
                        idx={idx + 'rev'}
                        value={member.revenueType} // {value, label}
                        options={revenueTypeOptions} // [{value, label}, ...]
                        openDropdown={openDropdownRevenue}
                        setOpenDropdown={setOpenDropdownRevenue}
                        onSelect={(option) => {
                          console.log('revenueType' + option.label);
                          updateMember(idx, 'revenueType', {
                            value: option.value,
                            label: option.label,
                          });
                          setOpenDropdownRevenue(null);
                        }}
                        placeholder="Select type"
                        searchable={false}
                        maxVisibleItems={5}
                        disabled={member.revenueType == 'approved'}
                        preselectedValue={preselectedBusinessNature}
                        parentClass={
                          member.revenueType == 'rejected'
                            ? 'border-[#FF5050] border-2'
                            : ''
                        }
                      />
                      {member.revenueType?.comments?.length > 0 && (
                        <StatusButton
                          status={member.revenueType?.status}
                          count={member.revenueType?.comments?.length || 0}
                          openSection={() =>
                            handleStatusClick(
                              member.revenueType,
                              'Revenue Type',
                              member.revenueType?.label,
                              '',
                            )
                          }
                        />
                      )}{' '}
                    </td>

                    {/* Country Type Dropdown */}
                    <td className="px-4 py-2">
                      <button
                        ref={(el) => (buttonRefs.current[idx] = el)}
                        onClick={() => handleDropdownToggle(idx)}
                        disabled={member.countryType.status == 'approved'}
                        className={`${
                          member.countryType.status == 'rejected'
                            ? 'border-[#FF5050] border-2'
                            : ''
                        } w-full h-10 rounded-xl text-sm px-3 flex justify-between items-center border bg-white`}
                      >
                        <span className="truncate">
                          {member.countryType.label || 'Select country'}
                        </span>
                        <img
                          src={
                            openDropdown === idx
                              ? '/Vector.svg'
                              : '/down-grey.svg'
                          }
                          className="w-3 h-3"
                          alt=""
                        />
                      </button>

                      <DropdownTDFetch
                        isOpen={openDropdown === idx}
                        buttonRef={buttonRefs.current[idx]}
                      >
                        <CountryDropdown
                          idx={idx}
                          member={member}
                          openDropdown={openDropdown}
                          onSelect={(option) => {
                            updateMember(idx, 'countryType', {
                              value: option.id,
                              label: option.name,
                            });
                            setOpenDropdown(null);
                          }}
                        />
                        {/* <CustomDropdownWithFetch
                label=""
                search={true}
                onSelect={handleSelectCountryType}
                colorLabel=""
                fetchOptions={getCountries} // <-- pass fetch function, not options
              /> */}
                      </DropdownTDFetch>
                      {member.countryType?.comments?.length > 0 && (
                        <StatusButton
                          status={member.countryType?.status}
                          count={member.countryType?.comments?.length || 0}
                          openSection={() =>
                            handleStatusClick(
                              member.countryType,
                              'Location',
                              member.countryType?.label,
                              '',
                            )
                          }
                        />
                      )}
                    </td>

                    {/* Asset Value Input */}
                    <td className="p-2">
                      <div className="w-full min-w-[180px] max-w-[220px]">
                        <div className="relative w-full">
                          {/* Dollar sign */}
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8C8C8C]">
                            {toCurrency.value.symbol}
                          </span>

                          <input
                            type="text"
                            placeholder="Asset Value"
                            disabled={member.assetValue.status == 'approved'}
                            className={`${
                              member.assetValue.status == 'rejected'
                                ? 'border-[#FF5050] border-2'
                                : ''
                            } w-full border border-gray-300 rounded-xl text-sm pl-8 p-2 focus:outline-none transition-all`}
                            value={member.assetValue.display ?? ''}
                            onChange={(e) => {
                              const raw = e.target.value.replace(
                                /[^0-9.]/g,
                                '',
                              );
                              updateMember(idx, 'assetValue', {
                                raw,
                                display: e.target.value,
                              });
                            }}
                            onBlur={() => {
                              const raw = member.assetValue.raw;
                              if (!raw) return;

                              // Format on blur
                              const formatted = new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(Number(raw));

                              updateMember(idx, 'assetValue', {
                                raw,
                                display: formatted,
                              });
                            }}
                          />
                        </div>
                      </div>
                      {member.assetValue?.comments?.length > 0 && (
                        <StatusButton
                          status={member.assetValue?.status}
                          count={member.assetValue?.comments?.length || 0}
                          openSection={() =>
                            handleStatusClick(
                              member.assetValue,
                              'Value of asset or income',
                              member.assetValue?.label,
                              '',
                            )
                          }
                        />
                      )}
                    </td>

                    {/* Delete Button */}
                    <td className="p-2 text-center">
                      <button
                        onClick={() => removeMember(idx)}
                        title="Remove"
                        className="text-red-500 hover:text-red-600 transition-colors"
                      >
                        <img
                          src="/trash.svg"
                          alt="Delete"
                          className="h-5 w-5 mx-auto"
                        />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-center mt-4 w-full">
            {stepStatus.length > 0 && stepStatus[0].status != 'APPROVED' && (
              <button
                onClick={addMember}
                className="text-[#375AE7] bg-white rounded-xl px-4 py-2 border-dashed border-2 text-sm"
              >
                + Add New
              </button>
            )}
          </div>
          {isUserPopOpen && (
            <AddUserPopup
              setactualData={setactualData}
              onClose={() => setisUserPopOpen(false)}
            />
          )}
        </div>
      )}
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      {countryType && countryTypeRiskFactor != 'high' && (
        <footer className=" bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
          {stepStatus.length > 0 &&
            stepStatus[0].status != 'COMPLETED' &&
            stepStatus[0].status != 'APPROVED' &&
            stepStatus[0].status != 'IN_REVIEW' && (
              <>
                <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                  <ConfirmResetButton
                    onConfirm={handleReset}
                    isReset={true}
                    isBack={false}
                    onBack={handleBack}
                  />
                </div>
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>

                  <ConfirmContinueButton
                    onContinue={() => handleContinue(true)}
                    buttonText="Continue"
                    confirmTitle="Save Section"
                    confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                  />
                </div>
              </>
            )}
          {stepStatus.length > 0 &&
            (stepStatus[0].status == 'COMPLETED' ||
              stepStatus[0].status == 'APPROVED' ||
              stepStatus[0].status == 'IN_REVIEW') && (
              <>
                <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                  <ConfirmResetButton
                    onConfirm={handleReset}
                    isReset={false}
                    isBack={false}
                    onBack={handleBack}
                  />
                </div>
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      setCurrentStep(2);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Next</span>
                  </button>
                </div>
              </>
            )}
        </footer>
      )}
    </div>
  );
};

export default TrustInfo;
